import { useId } from 'react';
import { colors } from '../design-tokens/colors.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const UploadIcon = ({
  color,
  fillPercentage,
  ...svgProps
}) => {
  const iconId = useId();
  const gradientId = `download-icon-${iconId.replace(/[^a-z0-9]/gi, "-")}-${fillPercentage ?? "default"}`;
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 26),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsxs("linearGradient", {
        id: gradientId,
        x1: "0%",
        x2: "0%",
        y1: "100%",
        y2: "0%",
        children: [/*#__PURE__*/jsx("stop", {
          offset: `${fillPercentage ?? 100}%`,
          stopColor: color ?? svgProps.stroke ?? "currentColor"
        }), typeof fillPercentage !== "undefined" && /*#__PURE__*/jsx("stop", {
          offset: `${fillPercentage ?? 100}%`,
          stopColor: colors.black(),
          stopOpacity: 0.2
        })]
      })
    }), /*#__PURE__*/jsx("path", {
      stroke: `url(#${gradientId})`,
      d: "M12 14v11M8.4 17.6 12 14l3.7 3.7M22.3 15a5.6 5.6 0 1 0-6.8-8.7 7.4 7.4 0 1 0-13 6.7"
    })]
  });
};

export { UploadIcon };
//# sourceMappingURL=upload.js.map
